import styled from 'styled-components'
import { NavPopover } from '.'
import { NextLink } from '@/features/shared/elements/Link'
import { Body, Link } from '@shipt/design-system-typography'
import { Column, Row } from '@shipt/design-system-layouts'
import { type Hyperlink } from '@/features/shared/constants/hyperlinks'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { Avatar } from '@shipt/design-system-avatar'

type Props = {
  links: Hyperlink[]
  title: string
  url?: string
}

export const LinksPopover = ({ links, title, url: menuItemUrl }: Props) => {
  return (
    <NavPopover title={title} url={menuItemUrl}>
      {({ closeTooltip }) => (
        <Column spacing="lg">
          {links.map((link) => {
            const LinkComponent = link.external ? ExternalLink : NextLink
            return (
              <Row align="center" spacing="sm" key={link.name}>
                {!!link.rectangular_image && (
                  <Avatar
                    type="image"
                    image={
                      <Image
                        src={link.rectangular_image}
                        alt={link.name}
                        fallbackType="store"
                        style={{ objectFit: 'contain' }}
                        width={24}
                        height={24}
                      />
                    }
                    size="sm"
                    colorScheme="plum"
                  />
                )}
                <LinkComponent href={link.url} onClick={closeTooltip}>
                  <LinkName>{link.name}</LinkName>
                </LinkComponent>
              </Row>
            )
          })}
        </Column>
      )}
    </NavPopover>
  )
}

const ExternalLink = styled(Link)`
  text-decoration: none;
`
const LinkName = styled(Body)`
  color: ${({ theme }) => theme.plum};

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`
